module.exports = __webpack_public_path__ + "img/website-banner.3c1ded4a.png";